import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getViewerWorkFlowCountSlice = createApi(`GetViewerWorkflowCountSlice`,"GET");

const GetViewerWorkflowCountSlice = createSlice({
  name: 'GetViewerWorkflowCountSlice',
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getViewerWorkFlowCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getViewerWorkFlowCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getViewerWorkFlowCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetViewerWorkflowCountSlice.reducer;